import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ?fokus=<id> aus der URL (Sprung aus dem Dashboard)
export const fokusId = () => new URLSearchParams(window.location.search).get('fokus');

// Sucht [data-fokus="<id>"], scrollt hin und rahmt den Eintrag ca. 3 s golden ein.
export const FokusMarker = () => {
  const { search, pathname } = useLocation();
  useEffect(() => {
    const id = new URLSearchParams(search).get('fokus');
    if (!id) return undefined;
    let n = 0;
    const t = setInterval(() => {
      const el = document.querySelector(`[data-fokus="${CSS.escape(id)}"]`);
      if (!el && ++n < 40) return;
      clearInterval(t);
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.remove('fokus-glow'); void el.offsetWidth; el.classList.add('fokus-glow');
      setTimeout(() => el.classList.remove('fokus-glow'), 3200);
    }, 250);
    return () => clearInterval(t);
  }, [search, pathname]);
  return null;
};
